/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";

// Importing icons for edit and delete actions
import edit_logo from "../../../../icons/edit.png";
import tash_logo from "../../../../icons/trash.png";

// Utility function to convert dates to UTC format
import convertToUTC from "../../../Common/Helpers/convertToUTC";

// The Tr component represents each table row with data and action options
export default function Tr({
  id, // Unique ID for the row item
  rarity_type, // Type of rarity (e.g., 'layerchoice')
  id_of_type, // Identifier specific to the rarity type
  starts_on, // Start date
  ends_on, // End date
  max_count, // Maximum count allowed
  onEdit, // Function to handle edit action
  onDelete, // Function to handle delete action
  status, // Status that affects the row's interactivity
}) {
  // State to store data fetched from the API based on rarity type
  const [rarityTypeData, setRarityTypeData] = useState();

  // Fetch name or preview image based on rarity type and id_of_type
  const getName = async () => {
    const res = await fetch(`/api/${rarity_type === "base image" ? "pattern" : rarity_type}/${id_of_type}/name`);
    const result = await res.json();
    if (rarity_type === "base image" || rarity_type === "layerchoice") {
      try {
        const previewImage =
          (result.preview && result.preview.startsWith("http")) ||
          result.preview.startsWith("https")
            ? result.preview
            : await getImage(result.preview);
        setRarityTypeData({ name: result.name, preview: previewImage }); // Update state
      } catch (error) {
        console.error("Error processing images:", error.message);
      }
    } else {
      setRarityTypeData(result);
    }
    // if (json) setRarityTypeData(json); // Update state with fetched data
  };

  const getImage = async (name) => {
    if (!name) {
      console.warn("No name provided for getImage.");
      return null;
    }

    try {
      const req = await fetch(`/api/file/name/${name}`);
      if (!req.ok) {
        throw new Error(`Failed to fetch image. Status: ${req.status}`);
      }

      const data = await req.json();

      if (!data?.image?.data) {
        throw new Error("Invalid image data received.");
      }

      const uint8Array = new Uint8Array(data.image.data);
      let binaryString = "";
      for (let i = 0; i < uint8Array.length; i++) {
        binaryString += String.fromCharCode(uint8Array[i]);
      }

      return `data:${data.type};base64,${btoa(binaryString)}`;
    } catch (error) {
      console.error(`Error in getImage for ${name}:`, error.message);
      return null; // Return null or fallback image URL
    }
  };

  // useEffect hook to fetch data when the component mounts
  useEffect(() => {
    getName();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <tr style={{ fontWeight: !status ? "normal" : "normal" }}>
        {/* Display rarity type, capitalized */}
        <td className="ps-5">
          {`${rarity_type.charAt(0).toUpperCase()}${rarity_type.slice(1)}`}
        </td>

        {/* Display either name or preview image based on rarity type */}
        <td
          style={{
            minWidth: "20rem",
            maxWidth: "20rem",
            whiteSpace: "pre-wrap",
            overflowWrap: "break-word",
          }}
          className="col-numeric-date"
        >
          {rarity_type === "background" ? (
            <div className="color-group">
              <div
                className="color-box"
                style={{ backgroundColor: rarityTypeData?.name, margin: 'auto' }}
              ></div>
            </div>
          ) : 
          rarity_type === "layer" ? 
            (<>
              {rarityTypeData?.name}
            </>)
          :
          (
            // Display name if not a layer choice
            <img
              src={rarityTypeData?.preview} // Display preview image for layer choice
              width={50}
              height={50}
              alt={rarityTypeData?.name}
            />
          )}
        </td>

        {/* Display start and end dates in UTC format */}
        <td className="col-numeric-date">
          {starts_on ? convertToUTC(starts_on) : null}
        </td>
        <td className="col-numeric-date">
          {ends_on ? convertToUTC(ends_on) : null}
        </td>

        {/* Display max count */}
        <td className="col-numeric-date">{max_count}</td>
        {/* Deployed or yet to deploy based on the status */}
        <td className="col-numeric-date">{status ? 'Active' : 'Pending'}</td>

        {/* Display edit and delete icons with conditional onClick actions */}
        <td className="col-options">
          {/* Edit action with conditional styling and onClick based on status */}
          <a
            onClick={(e) =>
              !status
                ? onEdit({
                    id,
                    name: rarityTypeData.preview
                      ? rarityTypeData.preview
                      : rarityTypeData.name,
                    rarity_type,
                    id_of_type,
                    starts_on,
                    ends_on,
                    max_count,
                  })
                : e.preventDefault()
            }
            style={{
              cursor: `${!status ? "pointer" : "not-allowed"}`,
            }}
          >
            <img className="edit-delete-icons" src={edit_logo} alt="Edit" />
          </a>
          &nbsp;
          {/* Delete action with conditional styling and onClick based on status */}
          <a
            onClick={(e) =>
              !status
                ? onDelete({ id, rarity_id: id, delete: true })
                : e.preventDefault()
            }
            style={{
              cursor: `${!status ? "pointer" : "not-allowed"}`,
            }}
          >
            <img
              className="edit-delete-icons ms-3"
              src={tash_logo}
              alt="Delete"
            />
          </a>
        </td>
      </tr>
    </>
  );
}
